import {
  Text,
  Tooltip,
  Popover,
  PopoverTrigger,
  IconButton,
  Portal,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  NoteIcon,
} from '@frontend/components';

import { linkify } from 'utils/urlUtils';

type WithPrivateNotes = {
  privateNotes: string | null;
};

type Quote = WithPrivateNotes & {
  number: number;
  id: number;
};

type Order = WithPrivateNotes & {
  number: number;
  id: number;
};

export type FooProps =
  | {
      quote: Quote;
      order?: never;
    }
  | { order: Order; quote?: never };

export const InternalNotesPopover = ({ quote, order }: FooProps) => {
  const item = quote || order;

  const { privateNotes } = item;

  const itemNumber = item.number || item.id;

  return (
    <Popover placement="right" size="sm">
      <PopoverTrigger>
        <IconButton>
          <Tooltip placement="bottom" label="Show notes" gutter={12}>
            <NoteIcon />
          </Tooltip>
        </IconButton>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverHeader>
            Internal Notes - {quote ? 'Quote' : 'Order'} #{itemNumber}
          </PopoverHeader>
          <PopoverBody>
            {privateNotes ? (
              linkify(privateNotes)
            ) : (
              <Text color="feature.secondary">No notes</Text>
            )}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
